// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip_e1e6f982 {
  padding: 0.5rem 1.334rem;
  line-height: 1.715;
  pointer-events: none;
}
.tooltip_e1e6f982.tooltip_dark_e1e6f982 {
  background-color: #11304d;
  color: #fff;
  border-color: #11304d;
  font-weight: 600;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltip": `tooltip_e1e6f982`,
	"tooltip_dark": `tooltip_dark_e1e6f982`
};
export default ___CSS_LOADER_EXPORT___;
